/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCommIn = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m7.707 10.354 1.414 1.414-3.231 3.231L22 15v2H5.768l3.353 3.354-1.414 1.414L2 16.06l1-1V15h.062zm8.597-8L20.951 7H21v.049l1.011 1.011-5.707 5.707-1.414-1.414L18.244 9H14V7h4.124L14.89 3.766zM4 7v2H2V7zm4 0v2H6V7zm4 0v2h-2V7z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCommIn as CommIn };
